import { render, staticRenderFns } from "./FeatUserAddedFields.vue?vue&type=template&id=339b0512&scoped=true"
import script from "./FeatUserAddedFields.vue?vue&type=script&lang=js"
export * from "./FeatUserAddedFields.vue?vue&type=script&lang=js"
import style0 from "./FeatUserAddedFields.vue?vue&type=style&index=0&id=339b0512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b0512",
  null
  
)

export default component.exports